<template>
  <div class="side-list pt-0 pb-4">
    <v-list-item @click="expand = !expand" style="font-size: 16px">
      <v-icon
        color="#757677"
        size="24"
        class="mr-0"
        :class="!expand ? 'rotate180' : null"
      >
        mdi-triangle-small-down
      </v-icon>
      <v-icon :color="color" size="16" class="mr-3">mdi-circle</v-icon>
      {{ title }}
    </v-list-item>
    <v-expand-transition>
      <div v-if="expand">
        <v-list-item-group :value="value" @input="(v) => $emit('input', v)">
          <v-hover
            v-for="item in !!search ? filteredlist : list"
            :key="`${title}:${item.index}`"
            @input="(v) => $emit('hover', { hover: v, data: item })"
          >
            <template #default="{ hover }">
              <v-list-item
                :ref="`list:${item.index}`"
                :input-value="hover"
                :value="item.index"
                @click="$emit('list-click', item)"
                @input="scroll(item.index)"
                style="position: relative"
              >
                <div class="flex-center w100p pl-11">
                  <div class="w80p text-truncate" style="display: inline-block">
                    <div class="v-icon" :class="getDotIcon(item)"></div>
                    {{ getName(item) }}
                  </div>
                </div>
                <v-list-item-icon style="position: absolute; right: 0">
                  <v-icon size="16" v-visible="hover">mdi-pencil</v-icon>
                  <v-icon
                    size="16"
                    v-visible="hover"
                    @click.stop="$emit('delete', item)"
                  >
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>
            </template>
          </v-hover>
        </v-list-item-group>
        <v-list-item
          v-if="search && !filteredlist.length"
          class="neutral300--text flex-center text-14px"
        >
          無結果
        </v-list-item>
        <v-list-item
          v-else-if="!list.length"
          class="neutral300--text flex-center text-14px"
        >
          {{ $t('ARTWORK.EDIT.WORD.NO_ITEMS') }}
        </v-list-item>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Object, Number],
      default: null
    },
    color: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    search: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    expand: true
  }),
  computed: {
    filteredlist() {
      if (!this.search) return [];
      const inputText = new RegExp(this.search, 'g');
      return this.list.filter((el) =>
        inputText.test(el.data.artworkName || el.data.name)
      );
    }
  },

  methods: {
    getName(item) {
      if (item && item.name) return item.name;
      return item && item.data ? item.data.artworkName || item.data.name : '';
    },
    scroll(index) {
      // TODO: thought it works, is not the accurate way
      const listItem =
        this.$refs[`list:${Number(index)}`] &&
        this.$refs[`list:${Number(index)}`][0];
      if (!listItem) return;

      const SIDE_LIST = document.getElementById('SIDE_LIST');
      if (!SIDE_LIST) return;
      SIDE_LIST.scrollTop = listItem.$el.offsetTop;
    },
    getDotIcon(dot) {
      if (dot.type === 'keyVision' && dot.data) return 'icon_post_outlined';
      if (dot.type === 'keyVision3D' && dot.data) return 'icon_stage_outlined';
      if (dot.type === 'wallVision') {
        return 'icon_note_outlined';
      }
      if (dot.type === 'staticArtwork') {
        return 'icon_photo_outlined';
      }
      if (dot.type === 'musicArtwork') {
        return 'icon_pod_outlined';
      }
      if (dot.type === 'videoArtwork') {
        return 'icon_video_outlined';
      }
      if (dot.type === 'modelArtwork') {
        return 'icon_box_outlined';
      }
      if (dot.type === 'websiteArtwork') {
        return 'icon_webpage_outlined';
      }
      return 'icon_IPFS_outlined';
    }
  }
};
</script>

<style lang="scss" scoped>
.side-list {
  ::v-deep {
    .v-list-item {
      min-height: 45px !important;
      max-height: 45px;
    }
  }
}
.rotate180 {
  transform: rotate(180deg);
}
.text-truncate {
  font-size: 14px;
  display: flex;
  align-items: center;
  color: $neutral300;
  .v-icon {
    &::before {
      content: '';
      background-size: contain;
      display: inline-block;
      font-size: inherit;
      text-rendering: auto;
      line-height: inherit;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      width: 18px;
      height: 18px;
    }
  }
}
.v-icon.v-icon {
  font-size: inherit;
  margin-right: 10px;
}
.icon_note_outlined {
  &::before {
    background-image: url(~@/assets/icons/map/icon_note_outlined.svg);
  }
}
.icon_youtube_outlined {
  &::before {
    background-image: url(~@/assets/icons/map/icon_youtube_outlined.svg);
  }
}
.icon_stage_outlined {
  &::before {
    background-image: url(~@/assets/icons/map/icon_stage_outlined.svg);
  }
}
.icon_IPFS_outlined {
  &::before {
    background-image: url(~@/assets/icons/map/icon_IPFS_outlined.svg);
  }
}
.icon_webpage_outlined {
  &::before {
    background-image: url(~@/assets/icons/map/icon_webpage_outlined.svg);
  }
}
.icon_box_outlined {
  &::before {
    background-image: url(~@/assets/icons/map/icon_box_outlined.svg);
  }
}
.icon_post_outlined {
  &::before {
    background-image: url(~@/assets/icons/map/icon_post_outlined.svg);
  }
}
.icon_pod_outlined {
  &::before {
    background-image: url(~@/assets/icons/map/icon_pod_outlined.svg);
  }
}
.icon_photo_outlined {
  &::before {
    background-image: url(~@/assets/icons/map/icon_photo_outlined.svg);
  }
}
.icon_video_outlined {
  &::before {
    background-image: url(~@/assets/icons/map/icon_video_outlined.svg);
  }
}
</style>